import React, { useEffect, useState, useRef } from "react";
import { Box, Link } from "@mui/material";
import { isTruncated } from "../../common/util";

export default function ProductDescription(props) {
  const ref = useRef(null);

  const { description } = props;

  const [truncate, setTruncate] = useState(true);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setShowMore(isTruncated(ref.current));
    }
  }, [ref.current]);

  return (
    <Box>
      <Box
        ref={ref}
        style={{
          color: "#6B6B6B",
          fontSize: ".9rem",
          overflow: "hidden",
          display: "-webkit-box",
          "-webkit-line-clamp": truncate ? "6" : "100",
          "line-clamp": truncate ? "6" : "100",
          "-webkit-box-orient": "vertical",
        }}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
      {truncate && showMore && (
        <Link
          color="primary"
          sx={{ cursor: "pointer" }}
          onClick={() => {
            setTruncate(false);
          }}
        >
          show more
        </Link>
      )}
    </Box>
  );
}
